import axios from 'axios'

import {
    ApiError,
    type ApiProblemDetails,
} from './api-error'

function getProblemDetails(
    data: unknown,
): ApiProblemDetails | undefined {
    if (
        typeof data !== 'object' ||
        data === null
    ) {
        return undefined
    }

    return data as ApiProblemDetails
}

export function normalizeApiError(
    error: unknown,
): ApiError {
    if (!axios.isAxiosError(error)) {
        if (error instanceof Error) {
            return new ApiError(
                error.message,
            )
        }

        return new ApiError(
            'An unexpected error occurred.',
        )
    }

    const problem = getProblemDetails(
        error.response?.data,
    )

    const message =
        problem?.detail ??
        problem?.title ??
        error.message ??
        'An unexpected API error occurred.'

    return new ApiError(
    message,
    {
        status:
            error.response?.status,

        errorCode:
            problem?.code,

        transportCode:
            error.code,

        problem,

        isNetworkError:
            !error.response,
    },
)
}